module.exports = __webpack_public_path__ + "media/images/weather/66_night-fc39d8e959c7037ed5a1afd92dc34d18.png";